/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRosreestrIcon32Regular = forwardRef('GovKoRosreestrIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 12C6 5.925 10.925 1 17 1s11 4.925 11 11c0 5.755-4.42 10.478-10.05 10.96A9.001 9.001 0 0 1 9 31H7.5A1.5 1.5 0 0 1 6 29.5V12Zm2.055-1A9.004 9.004 0 0 1 16 3.055V11H8.055ZM8 21v-8h8v8H8Zm0 2v6h1a7.001 7.001 0 0 0 6.93-6H8Zm17.945-10A9.004 9.004 0 0 1 18 20.945V13h7.945ZM18 3.055A9.004 9.004 0 0 1 25.945 11H18V3.055Z" })));
});
